@if (articleResult$ | async; as articleResult) {
    <div [innerHTML]="articleResult.articles[0].content"></div>
}
